import styled from 'styled-components';

import { type ProgressBarProps } from './Progressbar.typed';

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.GREY_LIGHT};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  overflow: hidden;
`;

const Bar = styled.div<ProgressBarProps>`
  background-color: ${({ theme }) => theme.colors.BLUE};
  height: 8px;
  width: 100%;
  @keyframes expand {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
  }
  animation-duration: ${({ animationDurationInMilliseconds }) =>
    animationDurationInMilliseconds}ms;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-name: expand;
`;

export { Container, Bar };
